import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getSettings } from './ReceptionStore';
import { getSlideShow } from './SlideStore';
// import { getAllPersons } from './PersonStore';
// import { getAllTeams } from './TeamStore';
// import { getAllColors, getAllPlans } from './PlannedItemStore';
// import { getAllDocuments } from './DocumentStore';
// import { getAllUnits, getAllBookings } from './ResourceStore';
// import { getFutureEvents } from './EventStore';
// import { getNews } from './DrNewsStore';
// import { getAllVintermanToday } from './WinterDutyStore';

export const reducerName = 'appStore';

export const refresh = createAsyncThunk(
    'appStore/refresh',
    async (_, { dispatch }) => {
        dispatch(getSettings());
        dispatch(getSlideShow(10040));
        dispatch(getSlideShow(10041));
        // dispatch(getAllPersons());
        // dispatch(getAllTeams());
        // dispatch(getAllColors());
        // dispatch(getAllPlans());
        // dispatch(getAllDocuments());
        // dispatch(getAllUnits());
        // dispatch(getAllBookings());
        // dispatch(getFutureEvents());
        // dispatch(getNews());
    }
);

const initialState = {
    lastRefresh: null,
};

const appSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(refresh.fulfilled, (state) => {
                state.lastRefresh = Date.now();
            });
    },
});

export default appSlice.reducer;
